<mat-card routerLink="{{ content().permalink }}" class="flex-col flex-justify-start flex-align-center"
  fxLayoutAlign.lt-md="center center">
  <div class="flex-col flex-justify-start flex-align-center grid-spaced-container">
    <a routerLink="{{ content().permalink }}">
      <img mat-card-image class="grid-image" src="{{ content().pathFoto }}" />
    </a>

    <mat-card-title-group class="grid-title-group">
      <mat-card-title class="grid-title">
        @if (content().premium) {
        <img class="icona-premium" src="assets/premium.png" /> }@if (content().template === 'articolo-riservato') {
        <mat-icon>https</mat-icon> }<a routerLink="{{ content().permalink }}">{{ content().titolo }}</a>
      </mat-card-title>
      <!-- <mat-card-subtitle class="flex-col flex-justify-center flex-align-center grid-detail">{{
        content.dataCreazione | date : 'dd/MM/yyyy' : 'UTC'
      }}</mat-card-subtitle> -->
    </mat-card-title-group>
    @if (content().descrizione) {
    <mat-card-content class="grid-description">
      <div class="grid-eyelet">
        <p>{{ content().descrizione }}</p>
      </div>
    </mat-card-content>
    }
  </div>
</mat-card>